import { SET_AIR_SEARCH_REQUEST, SET_SEARCH_RESULTS } from './actionTypes'
import { listingsFilterCall } from './listings'
import { toggleLoadingOverlay, setCurrentMobileFilter } from './uiToggles'
import { pushAd } from './ads'
import {
  setInitialFilterInfo,
  setCurrentFilterInfo,
  updateAirlineFiltersUI,
  updateAirlineFiltersReq,
  updateStopsFiltersUI,
  updateStopsFiltersReq,
  updateTimeFilters,
  resetTimeFilters,
  updateAirportsFiltersReq,
  updateAirportsFiltersUI,
  updateExactDateFiltersReq,
  updateExactDateFiltersUI,
  updateAttributesFiltersUI,
  updateAttributesFiltersReq,
} from './filters'

function setAirSearchRequest(searchRequest) {
  return {
    type: SET_AIR_SEARCH_REQUEST,
    searchRequest,
  }
}

function setSearchResults(data) {
  return {
    type: SET_SEARCH_RESULTS,
    data,
  }
}

export {
  setAirSearchRequest,
  setSearchResults,
  listingsFilterCall,
  setInitialFilterInfo,
  setCurrentFilterInfo,
  updateAirlineFiltersUI,
  updateAirlineFiltersReq,
  updateStopsFiltersUI,
  updateStopsFiltersReq,
  updateTimeFilters,
  resetTimeFilters,
  updateAirportsFiltersReq,
  updateAirportsFiltersUI,
  updateExactDateFiltersReq,
  updateExactDateFiltersUI,
  updateAttributesFiltersUI,
  updateAttributesFiltersReq,
  toggleLoadingOverlay,
  setCurrentMobileFilter,
  pushAd,
}
